import {
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Box,
  AccordionItem as ChakraAccordionItem,
} from '@gazin/ecommerce-ui'

export const AccordionItem = ({
  title,
  children,
}: {
  title: React.ReactNode
  children: React.ReactNode
}) => {
  return (
    <ChakraAccordionItem>
      <AccordionButton
        padding="0rem"
        height="2rem"
        _hover={{ bg: 'transparent' }}
      >
        <Box
          as="span"
          flex="1"
          textAlign="left"
          color={{ base: 'neutral.700', md: 'neutral.600' }}
          fontSize={{ base: '0.875rem', md: '1rem' }}
          fontWeight={{ base: '400', md: '700' }}
          lineHeight={{ base: '1.125rem', md: 'normal' }}
        >
          {title}
        </Box>
        <Box
          width="2rem"
          height="2rem"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <AccordionIcon color="neutral.500" boxSize="1.5rem" />
        </Box>
      </AccordionButton>
      <AccordionPanel padding="0rem" marginTop="0.5rem">
        {children}
      </AccordionPanel>
    </ChakraAccordionItem>
  )
}
